import initCarousel from '../helpers/carousel';
import { unitlessBreakpoints } from '../helpers/breakpoints';

export default class MainCollectionBanner {
  constructor(section) {
    this.el = section.el;

    initCarousel(
      this.el,
      {
        autoWidth: true,
        padding: {
          right: 15,
        },
        arrows: false,
        pagination: false,
        gap: '0.5rem',
        mediaQuery: 'min',
        breakpoints: {
          [unitlessBreakpoints.lg]: {
            gap: '1rem',
          },
        },
      },
      true,
    );
  }
}
